import { useId, useState } from "react";

function Disclosure({ title, children, defaultOpen = false }) {
  const [open, setOpen] = useState(defaultOpen);
  const panelId = useId();
  const titleId = useId();

  return (
    <div className={open ? "disclosure open" : "disclosure"}>
      <h3 className="disclosure-heading">
        <button
          type="button"
          className="disclosure-trigger"
          aria-expanded={open}
          aria-controls={panelId}
          onClick={() => setOpen((value) => !value)}
        >
          <span className="disclosure-title" id={titleId}>
            {title}
          </span>
          <span className="disclosure-mark" aria-hidden="true" />
        </button>
      </h3>
      <div
        id={panelId}
        role="region"
        aria-labelledby={titleId}
        className="disclosure-panel"
        inert={open ? undefined : true}
      >
        <div className="disclosure-panel-inner">
          <div className="disclosure-body">{children}</div>
        </div>
      </div>
    </div>
  );
}

export default Disclosure;
